window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, $(this.$container)).on('change', this._onSelectChange.bind(this));

    this._updateHistoryState(this.currentVariant);

    $('.variant-colors')
      .find('.variant-color-btn')
      .filter('[data-select-value="' + this.currentVariant.options[0] + '"]')
      .addClass('active');

    var that = this;

    $(".variant-color-btn").on('click touchstart', function () {
      $('.variant-color-btn').removeClass('active'); $(this).addClass('active');
      $(that.singleOptionSelector, $(that.$container)).on('change', that._onSelectChange.bind(that));
      $('.variant-colors select').val($(this).attr('data-select-value')).trigger('change');
    });
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
jQuery(document).ready( function($) {

  if( $('#votre-panier').length ) {
    if (makeupProductsCollection.length && cartItemsCollection.length) {    
      var hasOnlyMakeUpProducts = true;
      var makeupHandlesCollection = makeupProductsCollection.map(function(a){ return a.handle});
      cartItemsCollection.forEach(function(item) {
        if (!makeupHandlesCollection.indexOf(item.handle) >= 0) {
          hasOnlyMakeUpProducts = false;
        }
      });
      if (hasOnlyMakeUpProducts) {
        $('.cart--steps [data-cart-step=2]').hide();
        $('.cart--steps [data-cart-step=3] div:first-child').html('2');
        $('[data-cart-goto-step=2]').attr('disabled', 'disabled').hide();
        $('.cart-checkout-hidden').removeAttr('disabled', 'disabled').show();
      } else {
        $('.cart--steps [data-cart-step=2]').show();
        $('.cart--steps [data-cart-step=3] div:first-child').html('3');
        $('.cart-checkout-hidden').attr('disabled', 'disabled').hide();
        $('[data-cart-goto-step=2]').removeAttr('disabled', 'disabled').show();
      }
    }
    $('.loader').fadeOut();
  }
  
  var path = window.location.pathname;
  if($('body').hasClass('site-front') && path !== "/account/login" && path !== "/account/register" && path !== "/challenge") {
    var site_language = $('[data-site-language]').attr('data-site-language');
    var free_shipping_amount = parseInt($('[data-site-free-shipping]').attr('data-site-free-shipping'));
    var site_url = $('[data-site-url]').attr('data-site-url');
    var available_sample_products = parseInt($('[data-available-sample-products]').attr('data-available-sample-products'));

    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    }

    if(location.origin.indexOf('localhost') != -1) {
      site_language = 'fr';
      site_url = 'https://'+site_language+'.jouviance.com';
    }
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart_object) {
        // Remove Samples from cart
        if(cart_object.items.length > 0) {
          var promises = cart_object.items.map( function(item, index) {
            return new Promise( function(resolve, reject) {
              getProductData(item.handle, function(product_reference) {
                if(product_reference.tags.indexOf("échantillons") != -1) {
                  resolve(item);
                }
                else {
                  resolve(false);
                }
              });
            });
          });

          Promise.all(promises).then( function(data) {
            var has_samples = false;

            for(var i = 0; i < data.length; i++) {
              if(data[i] != false) {
                has_samples = true;
                break;
              }
            }

            if(has_samples) {
              var samples_to_remove = '';

              var samples = data.filter( function(sample) {
                return sample !== false;
              });

              samples.forEach( function(sample, index) {
                var sample_id = sample.id;

                if(index <= (samples.length -1) && index != 0) {
                  samples_to_remove += '&';
                }

                samples_to_remove += 'updates['+sample_id+']=0';
              });

              $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: samples_to_remove,
                complete: function(data) {
                  if($('body').hasClass('template-cart')) {
                    location.reload();
                  }
                }
              });
            }
          });
        }

        // Build the mini cart
        buildMiniCart(cart_object);
        // Adjust Checkout Button
        ajustCartCheckoutButton(cart_object.original_total_price);
      },
      error: function(data) {
        console.log('ERROR CART DATA: ' + data);
      }
    });

    function getProductData(item_handle, handleData) {
      $.ajax({
        type: 'GET',
        url: '/products/'+item_handle+'.js',
        dataType: 'json',
        success: function(data) {
          handleData(data);
        }
      });
    }

    function ajustCartCheckoutButton(cart_total) {
      if(location.origin.indexOf('localhost') == -1) {
        if(cart_total == 0) {
          $('.template-cart .buttons .btn').attr('disabled', 'disabled');
        }
      }
    }

    function buildMiniCart(data) {
      var $minicart = $('.mini-cart');
      var item_count = data['items'].length;
      var total_price = data['total_price']/100;

      if ( item_count > 0 ) {
        $minicart.attr('id', 'mini-cart');
        $('.cart-count', $minicart).text(item_count);
        $('.mini-cart-subtotal .price', $minicart).text( '$' + total_price.toFixed(2) );
      } else {
        $('.no-products', $minicart).addClass('visible');
        $('.mini-cart-subtotal .price', $minicart).text('$0.00');
      }

      if(total_price == 0) {
        $('#checkout', $minicart).attr('disabled', 'disabled');
      }

      if(total_price > free_shipping_amount) {
        $('.free-shipping').removeClass('visible');
      } else {
        var balance = (free_shipping_amount - total_price).toFixed(2);

        if(site_language == 'fr') {
          balance = balance + '$';
        } else {
          balance = '$' + balance;
        }

        $('.free-shipping .balance').text(balance);
        $('.free-shipping').addClass('visible');
      }
    }
  };

  $('[data-cart-goto-step]').on('click', function(e) {
    e.preventDefault();

    var next_step = $(this).attr('data-cart-goto-step');
    var current_step = $(this).closest('[data-cart-step]').attr('data-cart-step');

    // Adjust the URL
    history.pushState(null, '', '?cs='+ next_step +'&cache=false');

    // Scroll back to top
    window.scroll(0, 0);

    // Show the right section
    $('[data-cart-step="'+ current_step +'"]').removeClass('active');
    $('[data-cart-step="'+ next_step +'"]').addClass('active');
  });

  if(available_sample_products == 0) {
    $('[data-cart-step="2"]').hide();
    $('[data-cart-step="3"] > div').html('2');
  }
});

jQuery(document).ready( function($) {
  if($('body').hasClass('template-cart')) {
    var $message = $('.samples-title');
    var max_samples = $('[data-max-samples]', $message).attr('data-max-samples');
    var $cart_checkout_submit = $('#cart-checkout');
    var current_selection = 0;

    // Disable the checkout button
    $cart_checkout_submit.attr('disabled', 'disabled');
    $('.section--samples button[data-cart-goto-step="3"]').attr('disabled', 'disabled');

    $('.sample-tile [name="id"]').change( function(e) {
      $(this).closest('.sample-tile').attr('data-sample-id', $('option:selected', $(this)).val())
    });

    $('.sample-tile').on('click', function(e) {
      if($(e.target).is('select')) {
        return;
      }

      var $button = $('.btn', $(this));

      $(this).attr('data-sample-id', $('[name="id"]', $(this)).val())

      // Disable the event if the tile is disabled
      if(current_selection >= max_samples) {
        if(!$(this).hasClass('selected')) {
          return false;
        }
      }

      if($(this).hasClass('selected')) {
        current_selection = $('.sample-tile.selected').length - 1;

        $button.text($button.attr('data-text-selected'));
        $(this).removeClass('selected');
      }
      else {
        current_selection = $('.sample-tile.selected').length + 1;

        $button.text($button.attr('data-text-unselected'));
        $(this).addClass('selected');
      }

      if(current_selection >= max_samples) {
        current_selection = max_samples;

        $('.ongoing', $message).css('display', 'none');
        $('.done', $message).css('display', 'block');
      }
      else {
        $('.ongoing', $message).css('display', 'block');
        $('.done', $message).css('display', 'none');
      }

      // Append the message
      $('[data-max-samples]', $message).text(max_samples - current_selection);

      // Disable the remaining tiles if the max samples count is reached
      if(current_selection >= max_samples) {
        $('.sample-tile:not(.selected), .sample-tile:not(.selected) select').attr('disabled', 'disabled');

        // Allow the customer to checkout
        $cart_checkout_submit.removeAttr('disabled', 'disabled');
        $('.section--samples button[data-cart-goto-step="3"]').removeAttr('disabled', 'disabled');
      }
      else {
        $('.sample-tile, .sample-tile select').removeAttr('disabled', 'disabled');
        //Disallow the customer to checkout (he must choose the samples first).
        $cart_checkout_submit.attr('disabled', 'disabled');
        $('.section--samples button[data-cart-goto-step="3"]').attr('disabled', 'disabled');
      }
    });

    $cart_checkout_submit.on('click', function(e) {
      if(!$cart_checkout_submit.hasClass('samples-added')) {
        e.preventDefault();

        var promises;
        var selected_samples_ids = [];
        var $selected_samples = $('.sample-tile.selected');
        var $selected_upsell = $('.custom-upsell-product-row.active-add');
        
        $selected_upsell.each( function(index) {
        	selected_samples_ids.push($(this).attr('var_id'));
        });

        $selected_samples.each( function(index) {
          selected_samples_ids.push($(this).data('sample-id'));
          var product_position = index + 1;

          dataLayer.push({'event': 'push_cart',
            'product_name': strip_tags($('.product-title', $(this)).html()),
            'product_position': product_position
          });
        });

        var promises = selected_samples_ids.map( function(selected_samples_id) {
          return new Promise( function(resolve, reject) {
            $.ajax({
              type: "POST",
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              async: false,
              data: {id: selected_samples_id, quantity: 1},
              success: function() {
                resolve('Sample added to cart.');
              }
            });
          });
        });

        Promise.all(promises).then( function(data) {
          $cart_checkout_submit.addClass('samples-added');
          $cart_checkout_submit.trigger('click');
        });
      }
    });
  }

  function strip_tags(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;

    return tmp.textContent || tmp.innerText;
  }
//   $(".step__footer__previous-link").click(function() {
//   	location.reload();
//   });
});

theme.Christmas = (function() {
  if($('.christmas-boutique').length <= 0) return;

  $('.filters.mobile', '.christmas-boutique').on('change', function() {
    var url = $('option:selected', $(this)).val();
    window.location.href = location.protocol + '//' + location.host + url;
  });

  $('.slideshow .slides').cycle({
    'pager': '.pager',
    'pagerTemplate': '<span class="pager-button"></span>',
    'pauseOnHover': true,
    'swipe': true,
    'fx': 'scrollHorz',
    'swipeFx': 'scrollHorz'
  })
  .on('cycle-update-view', function(event, optionHash) {
    var $slideshowButtons = $('.slideshow .button:not([data-goto-slide="'+ parseInt(optionHash.currSlide) +'"])');
    var $currentSlideshowButton = $('.slideshow [data-goto-slide="'+ parseInt(optionHash.currSlide) +'"]');
    $slideshowButtons.each( function() {
      $(this).removeClass('selected');
      $('img', $(this)).attr('src', $(this).attr('data-unselected-icon'));
    });
    $currentSlideshowButton.addClass('selected');
    $('img', $currentSlideshowButton).attr('src', $currentSlideshowButton.attr('data-selected-icon'));
  });

  var $slideshowButtons = $('.slideshow .button');

  $slideshowButtons.on('click', function(e) {
    e.preventDefault();
    $('.slideshow .slides').cycle('goto', $(this).attr('data-goto-slide'));
    $slideshowButtons.each( function() {
      $(this).removeClass('selected');
      $('img', $(this)).attr('src', $(this).attr('data-unselected-icon'));
    });
    $(this).addClass('selected'); $('img', $(this)).attr('src', $(this).attr('data-selected-icon'));
  });

  var date = new Date();
  var $countdown = $(".countdown");
  $countdown.countdown(date.getFullYear()+"/12/25", function(event) {
    $('.days span', $countdown).text(event.strftime('%D'));
    $('.hours span', $countdown).text(event.strftime('%H'));
    $('.minutes span', $countdown).text(event.strftime('%M'));
    $('.seconds span', $countdown).text(event.strftime('%S'));
  });

  if(!window.location.hash) {
    var pageUrl = window.location.pathname + '#products';
  } else {
    pageUrl = window.location.pathname + window.location.search + window.location.hash;
  }

  $('.filters li a').each(function() {
    if($(this).attr('href') === pageUrl) {
      $(this).parent('li').addClass('filter--active');
    }
  });

  $('.filters.mobile option').each(function() {
    if($(this).attr('value') === pageUrl) {
      $(this).attr('selected', 'selected');
    }
  });  
})();

/**
 * Carousel Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace carousel
 */

theme.Carousel = (function() {

  setTimeout( function() {
    $('.items').animate({'opacity': 1}, 750);
  }, 1500);

  $('.pagination a').on('click.carousel', function(e) {
    var current_item = e.currentTarget.dataset.carouselItem;
    showItem(current_item);
  });

  function showItem (item) {
    item = parseInt(item);
    $('.carousel').attr('data-current-item', item);
    $('.carousel').find('.items .item').removeClass('current').eq(item-1).addClass('current');
    $('.carousel').find('.pagination li').removeClass('current').eq(item-1).addClass('current');
  }

  showItem(1);

})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Tabs Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Tabs template.
 *
   * @namespace tabs
 */

theme.Tabs = (function() {

  function Tabs() {

    var $sections = $('.section--tabs');
    if ( $sections.length ) {

      var $titles = $sections.find('h2');

      if( $titles.length === 0 || $(window).width() < 750) {
          $('.content', $sections).css('display', 'block');
        $('.notice').addClass('no-tabs');
      } else {

        var contentTabs = $titles.map(function () {
          return {
            title: $(this).text(),
            content: $(this).nextUntil('h2').toArray().reduce(function (acc, current) {
              return acc + current.outerHTML;
            }, '')
          };
        });

        contentTabs.toArray().forEach(function(contentTab, index){
          $class = '';
          if (index === 0) $class = 'current';
          $sections.find('.tabs').append('<li><h2><a href="#" class="' + $class + '" data-tab-link="' + index + '">' + contentTab.title + '</a></h2></li>');
          $sections.find('.tab-content').append('<li data-tab-content="' + index + '">' + contentTab.content + '</li>');
          $sections.attr('data-tab-current', 0);
        });

        $sections.find('.tabs a').on('click.tabs', function(e) {
          e.preventDefault();
          var current_tab = e.currentTarget.dataset.tabLink;
          $sections.find('.tabs .current').removeClass('current');
          $(e.currentTarget).addClass('current');
          $sections.attr('data-tab-current', current_tab);
        });
      }

    }
  }

  return Tabs;

})();

/**
 * WidgetTabs Template Script
 * ------------------------------------------------------------------------------
 * Classy and accessible tabs.
 *
   * @namespace contenttabs
 */

theme.WidgetTabs = (function() {

  function WidgetTabs() {

    $('[data-widget="tabs"]').each(function() {
      var that = this;
      var tabs = $(this).find('[role="tab"]');
      var tabpanels = $(this).find('[role="tabpanel"]');

      tabs.attr('tabindex', 0).attr('aria-selected', false);
      tabpanels.attr('aria-hidden', true);

      tabs.on('click', function() {
        tabs.filter(function() {
          return $(this).attr('aria-selected') == 'true';
        }).attr('aria-selected', false);

        tabpanels.filter(function() {
          return $(this).attr('aria-hidden') == 'false';
        }).attr('aria-hidden', true);

        $(this).attr('aria-selected', true);
        tabpanels.filter('[aria-labelledby="' + $(this).attr('id') + '"]').attr('aria-hidden', false);
      });

      tabs.first().trigger('click');
    });
  }

  return WidgetTabs;

})();

/**
 * Menu Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts for mobile menu
 *
   * @namespace menu
 */

jQuery(document).ready( function($) {
  // Mobile Menu
  $('.mobile-menu-trigger').on('click', function() {
    var $body = $('body');

    if($(this).hasClass('on')) {
      $(this).removeClass('on');
      $body.removeClass('mobile-menu-opened');
      $('.site-nav').removeClass('visible');
    }
    else {
      $(this).addClass('on');
      $body.addClass('mobile-menu-opened');
      $('.site-nav').addClass('visible');
    }
  });

  // Desktop Submenu
  if($(window).width() >= 892) {
    $('.site-nav--has-submenu').mouseover( function() {
      $('.submenu', $(this)).addClass('visible');
    })
    .mouseleave( function() {
      $('.submenu', $(this)).removeClass('visible');
    });
  }
  else {
    $('.site-nav--has-submenu .icon-arrow').click( function(e) {
      var $parent = $(this).closest('.site-nav--has-submenu');
      var $submenu = $('.submenu', $parent);

      e.preventDefault();

      if($submenu.hasClass('visible')) {
        $parent.removeClass('submenu-visible');
        $submenu.removeClass('visible');
      }
      else {
        $parent.addClass('submenu-visible');
        $submenu.addClass('visible');
      }
    })
  }

  var search = true;
  $('.search-container .fa-search').on('click', function() {
    if (search) {
      $('.search-container .fa-search').removeClass('fa-search').addClass('fa-close');
      $('.site-search-form').removeClass('invisible').addClass('visible');
      $('#Search').focus();
      return search = false;
    } else {
      $('.search-container .fa-close').removeClass('fa-close').addClass('fa-search');
      $('.site-search-form').removeClass('visible').addClass('invisible');
      return search = true;
    }
  })
});

/**
 * Feedback Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts for feedback template
 *
   * @namespace feedback
 */

theme.Feedback = (function() {

  var $collections = $('.collections [data-collection]', '.section--feedback');
  var $collections_select = $('.collections select', '.section--feedback');
  var $products = $('.products [data-collection]', '.section--feedback');
  var $products_select = $('.products select', '.section--feedback');
  var $products_parent = $('.products', '.section--feedback');

  function Feedback() {

    $(window).on('load', function() {
      if($(window).width() <= 750) {
        var pattern_success = /[?&]cache=false&collection/;
        var URL = location.search;

        if(pattern_success.test(URL) || pattern_error.test(URL)) {
          $("html, body").stop().animate({scrollTop: $(".product-information").offset().top - 100}, 500);
        }
      }
    });

    // Show product list
    $collections.on('click', function() {
      $collections.removeClass('active');
      $products.removeClass('visible');

      $(this).addClass('active');
      $('.products [data-collection="'+ $(this).data('collection') +'"]').addClass('visible');
    });

    $collections_select.on('change', function() {
      $collections.removeClass('active');
      $products.removeClass('visible');

      $(this).addClass('active');
      $products_parent.addClass('visible');
      $('.products select[data-collection="'+ $('option:selected', $(this)).data('collection') +'"]').addClass('visible');
    });

    // Load product information
    $('.products li', 'section--feedback').click( function() {
      var collection_handle = $(this).closest('[data-collection]').data('collection');
      var product_handle = $(this).data('product');

      window.location.href = location.protocol + '//' + location.host + location.pathname + '?cache=false&collection='+collection_handle+'&product=' + product_handle;
    });

    $products_select.on('change', function() {
      var collection_handle = $(this).closest('[data-collection]').data('collection');
      var product_handle = $('option:selected', $(this)).data('product');

      window.location.href = location.protocol + '//' + location.host + location.pathname + '?cache=false&collection='+collection_handle+'&product=' + product_handle;
    });
  }

  return Feedback;

})();

theme.Mailchimp = (function() {

  var $container = $('.mailchimp-ajax');
  var language = $('[name="language"]', $container).val();

  $('[type="submit"]', $container).click( function() {
    var email_address = $('[name="email"]', $container).val();

    $container.append('<img src="https://cdn.shopify.com/s/files/1/1871/7021/files/Spin.gif?3847845495965904996" class="spinner" alt="Loading" />');
    var $spinner = $('.spinner');

    $.post("https://4hn1m84col.execute-api.us-east-1.amazonaws.com/production/lists/f67765e8f0/members", JSON.stringify({
      'email_address': email_address,
      'status': 'subscribed',
      'merge_fields': {
        'LANGUAGE': language.toUpperCase()
      }
    }))
    .always( function(data) {
      $spinner.remove();

      if(data.status == 200) {
        if(language == 'fr') {
          $('.message').empty().html('Vous êtes maintenant inscrit à notre infolettre');
        }
        else {
          $('.message').empty().html('You are now subscribed to our newsletter');
        }

        return;
      }
      else {
        if(language == 'fr') {
          $('.message').empty().html('Il semble y avoir une erreur avec votre adresse courriel. Veuillez vérifier votre courriel.');
        }
        else {
          $('.message').empty().html('There seems to be an error with your email address. Please check your email.');
        }
      }
    });
  });

})();

jQuery(document).ready( function($) {
  var $container = $('.popup--newsletter');

  var subscriber_infos = {
    email: '',
    language: '',
    gender: '',
    concern: '',
    birthday: ''
  };

  $('.popup--newsletter').on('click', function(e) {
    if($(e.target).hasClass('popup--newsletter')) {
      $('.active .popup--close').trigger('click');
    }
  });

  $('.popup--close, .step-3 .btn', $container).on('click', function(e) {
    e.preventDefault();

    $(this).closest('.popup').removeClass('visible');
    $('body').removeClass('modal-is-opened');

    createCookie("stopShowingNewsletterPopup", true, 7);
  });

  $('.step-1 [type="submit"]', $container).click( function(e) {
    e.preventDefault();

    subscriber_infos.email = $('[name="email"]', $container).val();
    subscriber_infos.language = $('[name="language"]', $container).val();
    var condition_are_accepted = $('#newsletter-subscribe-conditions', $container).is(':checked');

    if(subscriber_infos.email && condition_are_accepted) {
      $('.step-1').removeClass('active');
      $('.step-2').addClass('active');
    }
    else {
      $('[name="email"]', $container).addClass('error');
      $('#newsletter-subscribe-conditions', $container).addClass('error');
    }
  });

  $('.step-2 .btn--secondary, .step-2 .popup--close', $container).click( function(e) {
    e.preventDefault();

    subscribeToNewsletter(subscriber_infos);
  });

  $('.step-2 [type="submit"]', $container).click( function(e) {
    e.preventDefault();

    subscriber_infos.fname = $('[name="firstname"]', $container).val();
    subscriber_infos.lname = $('[name="lastname"]', $container).val();
    subscriber_infos.gender = $('[name="gender"]', $container).val();
    subscriber_infos.concern = $('[name="concern"]', $container).val();
    subscriber_infos.birthday = $('[name="birthday"]', $container).val();

    subscribeToNewsletter(subscriber_infos);

    $('.step-2', $container).removeClass('active');
    $('.step-3', $container).addClass('active');
  });
});

function subscribeToNewsletter(subscriber_infos) {
  $.post("https://4hn1m84col.execute-api.us-east-1.amazonaws.com/production/lists/f67765e8f0/members", JSON.stringify({
    'email_address': subscriber_infos.email,
    'status': 'subscribed',
    'merge_fields': {
      'LANGUAGE': subscriber_infos.language.toUpperCase(),
      'FNAME': subscriber_infos.fname,
      'LNAME': subscriber_infos.lname,
      'GENDER': subscriber_infos.gender,
      'CONCERN': subscriber_infos.concern,
      'BIRTHDAY': subscriber_infos.birthday,
    }
  }))
  .always( function(data) {
    console.log(data);
  });
}

function showNewsletterPopup() {
  var cookie = document.cookie;

  if(readCookie("stopShowingNewsletterPopup") != "true") {
    $('.popup--newsletter').addClass('visible');
    $('body').addClass('modal-is-opened');
  }
}

function createCookie(name, value, days) {
  var date, expires;

  if (days) {
    date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
  } else {
    expires = "";
  }

  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1,c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length,c.length);
    }
  }

  return null;
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

jQuery(document).ready( function($) {
  var $container = $('.section--newsletter');
  var subscriber_infos = {};

  $('[type="submit"]', $container).click( function(e) {
    e.preventDefault();

    subscriber_infos.email = $('[name="email"]', $container).val();
    subscriber_infos.language = $('[name="language"]', $container).val();
    var condition_are_accepted = $('#footer-newsletter-subscribe-conditions', $container).is(':checked');

    if(subscriber_infos.email && condition_are_accepted) {
      $('.step-1').removeClass('active');
      $('.step-2').addClass('active');
      subscribeToNewsletter(subscriber_infos);
    }
    else {
      $('[name="email"]', $container).addClass('error');
      $('#footer-newsletter-subscribe-conditions', $container).addClass('error');
    }
  });
});

function subscribeToNewsletter(subscriber_infos) {
  $.post("https://4hn1m84col.execute-api.us-east-1.amazonaws.com/production/lists/f67765e8f0/members", JSON.stringify({
    'email_address': subscriber_infos.email,
    'status': 'subscribed',
    'merge_fields': {
      'LANGUAGE': subscriber_infos.language.toUpperCase()
    }
  }))
  .always( function(data) {
    console.log(data);
  });
}


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.About = (function() {
  $('.icon-details').mouseenter( function(e) {
    $('#tooltip-'+$(this).attr('data-tooltip-id')).fadeIn();
  }).mouseleave( function(e) {
    $('#tooltip-'+$(this).attr('data-tooltip-id')).stop(true, true).fadeOut();
  });

  $('.page-about-subnav [data-tab-id]').on('click', function() {
    var tab_id = $(this).attr('data-tab-id');

    $('.page-about-subnav [data-tab-id]').removeClass('active');
    $(this).addClass('active');

    $('.subcontent .tab').removeClass('active');
    $('.subcontent .tab#'+tab_id).addClass('active');

    history.pushState(null, null, location.protocol + '//' + location.host + location.pathname + "?cache=false&current_tab=" + tab_id);
  });

  $('.blacklist [data-info-id]').on('click', function() {
    var tab_id = $(this).attr('data-info-id');

    $('.blacklist [data-info-id]').removeClass('active');
    $(this).addClass('active');

    $('.ingredient').removeClass('active');
    $('.ingredient#'+tab_id).addClass('active');
  });
})();

theme.Magistrale = (function() {

  if($('body').attr('id') == 'magistrale') {
    var percentageAnimationDone = false;

    $(window).scroll(function() {
      if(!percentageAnimationDone) {
        if(isScrolledIntoView('.percentage')) {
          $('.percentage .inner').each(function () {
            $(this).parent('.percentage').addClass('animate');
            $(this).prop('Counter', 0).animate({
              Counter: $(this).text()
            }, {
              duration: 2000,
              easing: 'swing',
              step: function (now) {
                $(this).text(Math.ceil(now));
              }
            });

            percentageAnimationDone = true;
          });
        }
      }
    });

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    if($(window).width() <= 892) {
      $('.ingredients [data-ingredient]').on('click', function() {
        var tab_id = $(this).attr('data-ingredient');

        $('.ingredients [data-ingredient]').removeClass('active');
        $(this).addClass('active');

        $('[data-ingredient-id]').removeClass('visible');
        $('[data-ingredient-id="'+tab_id+'"]').addClass('visible');

        $("html, body").stop().animate({scrollTop: $(".ingredients-details").offset().top - 100}, 1000);
      });
    }
    else {
      $('.ingredients [data-ingredient]').on('mouseover', function() {
        var tab_id = $(this).attr('data-ingredient');

        $('.ingredients [data-ingredient]').removeClass('active');
        $(this).addClass('active');

        $('[data-ingredient-id]').removeClass('visible');
        $('[data-ingredient-id="'+tab_id+'"]').addClass('visible');
      });
    }
  }

})();

theme.Contour = (function() {

  if($('body').attr('id') == 'contour-plus') {

    // Toggle procuct part description
    $('.section--list-selected .lists .list-item').each(function() {
      $(this).on('click', function() {
        if (!$(this).hasClass('active')) {
          $('.active').removeClass('active');
          $(this).addClass('active');
        }
      });
    })

    // Numbers evolution
    var percentageAnimationDone = false;

    $(window).scroll(function() {
      if(!percentageAnimationDone) {
        if(isScrolledIntoView('.percentage')) {
          $('.percentage .number').each(function () {
            $(this).parent('.percentage').addClass('animate');
            $(this).prop('Counter', 0).animate({
              Counter: $(this).text()
            }, {
              duration: 2000,
              easing: 'swing',
              step: function (now) {
                $(this).text(Math.ceil(now));
              }
            });

            percentageAnimationDone = true;
          });
        }
      }
    });

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
  }
})();

theme.Contour = (function() {

  if($('.section--landing-content').attr('id') == 'shopify-section-landing-hydractiv-coco') {

    // Toggle procuct part description
    $('.section--list-selected .lists .list-item').click( function() {
      var $parent = $(this).closest('.section--list-selected');
      if (!$(this).hasClass('active')) {
        $('.active', $parent).removeClass('active');
        $(this).addClass('active');
      }
    });

    // Numbers evolution
    var percentageAnimationDone = false;

    $(window).scroll(function() {
      if(!percentageAnimationDone) {
        if(isScrolledIntoView('.percentage')) {
          $('.percentage .number').each(function () {
            $(this).parent('.percentage').addClass('animate');
            $(this).prop('Counter', 0).animate({
              Counter: $(this).text()
            }, {
              duration: 2000,
              easing: 'swing',
              step: function (now) {
                $(this).text(Math.ceil(now));
              }
            });

            percentageAnimationDone = true;
          });
        }
      }
    });

    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset().top;
      var elemBottom = elemTop + $(elem).height();

      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
  }
})();



$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  theme.Tabs();
  theme.WidgetTabs();
  theme.Feedback();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});


//  custom js

$('.featured_collection .products ul li .product--aside .info a.product_detail.btn--black-bg').addClass('btn');



// bundle product //
$(".varient_dropdown").load(function(){
  var element = $(this);
  var option = $(this).find('option:selected').attr('price');
  $(".varient_price").append(option);
});


var product_one_option = $('.product_one .varient_dropdown').find('option:selected').attr('price');
var product_two_option = $('.product_two .varient_dropdown').find('option:selected').attr('price');
var product_three_option = $('.product_three .varient_dropdown').find('option:selected').attr('price');
//var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);

if ( product_one_option) {
  var Totalprice = parseFloat(product_one_option) ;
  if ( product_one_option && product_two_option  ) {
    var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option);
  }
  if ( product_one_option && product_three_option  ) {
    var Totalprice = parseFloat(product_one_option)  + parseFloat(product_three_option);
  }
  if ( product_one_option && product_two_option &&  product_three_option ) {
    var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
  }
}




var prevVal;

$(function() {
  $(".product_one .varient_dropdown").change(function(){
    var element = $(this);
    var product_one_option_new = $(this).find('option:selected').attr('price');
    var product_one_id = $(this).find('option:selected').attr('id');
    
    product_one_option = product_one_option_new;
    //Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
    
    if ( product_one_option) {
      var Totalprice = parseFloat(product_one_option) ;
      if ( product_one_option && product_two_option  ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option);
      }
      if ( product_one_option && product_three_option  ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_three_option);
      }
      if ( product_one_option && product_two_option &&  product_three_option ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
      }
    }
    
	$('.varient_price').text(Totalprice);
    
    $('.product_one .varient_img').hide();
    $('#' + $(this).val()).show();
    
  });
});

$(function() {
  $(".product_two .varient_dropdown").change(function(){
    var element = $(this);
    var product_two_option_new = $(this).find('option:selected').attr('price');
    var product_two_id = $(this).find('option:selected').attr('id');
    
    product_two_option = product_two_option_new;
    // Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
    
    if ( product_one_option) {
      var Totalprice = parseFloat(product_one_option) ;
      if ( product_one_option && product_two_option  ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option);
      }
      if ( product_one_option && product_three_option  ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_three_option);
      }
      if ( product_one_option && product_two_option &&  product_three_option ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
      }
    }
    
	$('.varient_price').text(Totalprice);
    
	$('.product_two .varient_img').hide();
    $('#' + $(this).val()).show();
    
  });
});

$(function() {
  $(".product_three .varient_dropdown").change(function(){
    var element = $(this);
    var product_three_option_new = $(this).find('option:selected').attr('price');
    var product_three_id = $(this).find('option:selected').attr('id');
    
    product_three_option = product_three_option_new;
    //Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
    
    if ( product_one_option) {
      var Totalprice = parseFloat(product_one_option) ;
      if ( product_one_option && product_two_option  ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option);
      }
      if ( product_one_option && product_three_option  ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_three_option);
      }
      if ( product_one_option && product_two_option &&  product_three_option ) {
        var Totalprice = parseFloat(product_one_option)  + parseFloat(product_two_option) + parseFloat(product_three_option);
      }
    }
    
	$('.varient_price').text(Totalprice);
    
    $('.product_three .varient_img').hide();
    $('#' + $(this).val()).show();
    
  });
});


$(document).ready(function() {
  function totalproductprice() {
    //console.log('Totalprice', Totalprice);
    $(".varient_price").append(Totalprice);
  }
  totalproductprice();
});



function bundle(event) {
    //event.preventDefault();
    $(".add_to_bundle").attr('disabled',true);
    //$(".add_to_bundle span").prepend('<i class="fa fa-spinner fa-spin">')
    var product_array = [];
  
    $(".custom-collection-link").each( function (index, ele) {
      var acc_ids = $(ele).find('select option:selected').attr("value");
      var varient_price = $(ele).find('select option:selected').attr("price");
      console.log('varient_price', varient_price);
      product_array.push({
        quantity: 1,
        id: acc_ids
      });
  });
   
    console.log("product_array :::", product_array);
    // var feedback = '<p class="feedback">Your Product addded SucessFlly. <a href="/cart">Go to Cart</a></p>';

    jQuery.post('/cart/add.js', {
        items: product_array,
        success: function(response){
          console.log('in success::::',response);
          setTimeout(function(){
            $(".add_to_bundle").attr('disabled',false);
            //$(".add_to_bundle span i").remove();
            location.href = "/cart";
            updateCart();
              //$('.bundle-btn').append(feedback);
               //$('#sidebar-cart').load(document.URL +  ' #sidebar-cart > *');
               //$('#open-sidebarD').trigger( "click" );
          },3000);
        },
    });
};

function updateCart(){
      var cartItemCounter = document.querySelector('span.Header__CartCount');
      jQuery.ajax('https://jouviance-dev.myshopify.com/cart.js').done(function(data){
        var CartItem = JSON.parse(data);
        cartItemCounter.innerHTML = CartItem.item_count;
        console.log(CartItem.item_count);
      });
}

// bundle product //

// Upsell product js

$(function(){
  if($('body').hasClass('template-cart')){
    
    var site_language = $('[data-site-language]').attr('data-site-language');
    $('.custom-upsell-product-row').not(':first').remove();
    
//     $('.custom-upsell-product-row').click(function(){
//     var current = $(this);
//       $(this).toggleClass('active-add');
//     });

    $('.upsell-to-car').click(function(event){
      event.preventDefault();
      var current = $(this);
      var var_id = $(this).attr('var_id');
      $(this).attr("disabled","disabled");
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: var_id
      },
                  null,
                  "json"
                 ).done(function () {
        $(current).val('Added');
        location.href = 'https://jouviance-dev.myshopify.com/cart?cs=3&cache=false';
      })
      .fail(function ($xhr) {
        var data = $xhr.responseJSON;
        alert(data);
      });
    });
    
  }
});

function processCart() {
  jQuery.post('/cart/add.js', {
    quantity: qty,
    id: var_id
  },
              null,
              "json"
             ).done(function () {
    $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
  })
  .fail(function ($xhr) {
    var data = $xhr.responseJSON;
    $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
  });
}
